import { AppState } from 'store';

export const isFaqOpenSelector = ({ faqState }: AppState): boolean => faqState?.faqOpen;
